export const WHITE = '#FFFFFF';
export const BLACK = '#000000';

export const GREY_10 = 'rgba(255, 255, 255, 1)';
export const GREY_10_70 = 'rgba(255, 255, 255, 0.7)';
export const GREY_20 = 'rgba(249, 249, 253, 1)';
export const GREY_30 = 'rgba(221, 224, 234, 1)';
export const GREY_40 = 'rgba(144, 148, 165, 1)';
export const GREY_40_10 = 'rgba(144, 148, 165, 0.1)';
export const GREY_40_20 = 'rgba(144, 148, 165, 0.2)';
export const GREY_40_50 = 'rgba(144, 148, 165, 0.5)';
export const GREY_40_75 = 'rgba(144, 148, 165, 0.75)';
export const GREY_50 = 'rgba(86, 91, 108, 1)';
export const GREY_60 = 'rgba(58, 61, 74, 1)';
export const GREY_70 = 'rgba(30, 30, 34, 1)';
export const GREY_80 = 'rgba(18, 18, 22, 1)';
export const GREY_80_50 = 'rgba(18, 18, 22, 0.5)';
export const GREY_80_75 = 'rgba(18, 18, 22, 0.75)';
export const GREY_90 = 'rgba(0, 0, 0, 1)';

export const PINK_OR_PURPLE = 'rgba(212, 0, 247, 1)';
export const PINK_OR_PURPLE_50 = 'rgba(212, 0, 247, 0.5)';
export const PINK_OR_PURPLE_25 = 'rgba(212, 0, 247, 0.25)';
export const PINK_OR_PURPLE_10 = 'rgba(212, 0, 247, 0.10)';

export const PINKLING = 'rgba(225, 92, 247, 1)';
export const PINKLING_10 = 'rgba(225, 92, 247, 0.10)';
export const PINKLING_50 = 'rgba(225, 92, 247, 0.5)';
export const PINKLING_25 = 'rgba(225, 92, 247, 0.25)';

export const BABY_ELEPHANT = 'rgba(237, 210, 246, 1)';
export const BABY_ELEPHANT_15 = 'rgba(237, 210, 246, 0.15)';
export const BABY_ELEPHANT_30 = 'rgba(237, 210, 246, 0.30)';

export const BABY_ELEPHANT_DARK = 'rgba(233, 193, 246, 1)';
export const BABY_ELEPHANT_DARKER = 'rgba(220, 165, 238, 1)';

export const ERROR_LIGHT = 'rgba(255, 0, 92, 1)';
export const ERROR_LIGHT_15 = 'rgba(255, 0, 92, 0.15)';
export const ERROR_DARK = 'rgba(255, 80, 143, 1)';
export const ERROR_DARK_15 = 'rgba(255, 80, 143, 0.15)';

export const SUCCESS_LIGHT = 'rgba(0, 172, 16, 1)';
export const SUCCESS_LIGHT_15 = 'rgba(0, 172, 16, 0.15)';
export const SUCCESS_DARK = 'rgba(111, 236, 123, 1)';
export const SUCCESS_DARK_15 = 'rgba(111, 236, 123, 0.15)';

export const PENDING_LIGHT = 'rgba(38, 122, 255, 1)';
export const PENDING_LIGHT_15 = 'rgba(38, 122, 255, 0.15)';
export const PENDING_DARK = 'rgba(133, 181, 255, 1)';
export const PENDING_DARK_15 = 'rgba(133, 181, 255, 0.15)';

export const WARNING_LIGHT = 'rgba(233, 144, 49, 1)';
export const WARNING_LIGHT_15 = 'rgba(233, 144, 49, 0.15)';
export const WARNING_DARK = 'rgba(255, 176, 73, 1)';
export const WARNING_DARK_15 = 'rgba(255, 176, 73, 0.15)';
